import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-222325fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cls-flex",
  style: {"flex-direction":"column","height":"100vh"}
}
const _hoisted_2 = { style: {"width":"100%"} }
const _hoisted_3 = { style: {"padding":"0.5rem"} }
const _hoisted_4 = {
  key: 0,
  class: "scroll"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["item", "onClick"]
const _hoisted_7 = {
  key: 0,
  class: "cart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_tree_select = _resolveComponent("van-tree-select")!
  const _component_Tabbar = _resolveComponent("Tabbar")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_search, {
          modelValue: _ctx.reqData.text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reqData.text) = $event)),
          shape: "round",
          placeholder: "请搜索服务",
          onSearch: _ctx.req_serveList
        }, null, 8, ["modelValue", "onSearch"])
      ]),
      _createVNode(_component_van_tree_select, {
        style: {"flex":"1","width":"100%"},
        onClickNav: _ctx.nav_change,
        "main-active-index": _ctx.navIdx,
        "onUpdate:mainActiveIndex": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.navIdx) = $event)),
        items: _ctx.sortList
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.sortList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortList[_ctx.navIdx].childrenList, (sort, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: sort.id,
                      style: {"margin-right":"0.5rem"}
                    }, [
                      (index == _ctx.sortIdx)
                        ? (_openBlock(), _createBlock(_component_van_tag, {
                            key: 0,
                            color: "#FFFAF2",
                            "text-color": "#D8C14F",
                            style: {"padding":"0.2rem 0.5rem"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sort.sortName), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_van_tag, {
                            key: 1,
                            color: "#F6F6F6",
                            "text-color": "#AAAAAA",
                            style: {"padding":"0.2rem 0.5rem"},
                            onClick: ($event: any) => (_ctx.sort_change(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sort.sortName), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_van_tag, {
                    color: "#FFFAF2",
                    "text-color": "#D8C14F",
                    style: {"padding":"0.2rem 0.5rem"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  })
                ])),
            _createVNode(_component_van_list, {
              loading: _ctx.loading,
              "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
              finished: _ctx.finished,
              "finished-text": _ctx.list.length ? '没有更多了' : '此分类暂无产品',
              error: _ctx.error,
              "onUpdate:error": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.error) = $event)),
              "error-text": "加载失败，点击重试",
              onLoad: _ctx.req_items
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    item: item,
                    onClick: ($event: any) => (_ctx.item_click(item, i))
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentItem), { item: item }, null, 8, ["item"]))
                  ], 8, _hoisted_6))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "finished", "finished-text", "error", "onLoad"])
          ])
        ]),
        _: 1
      }, 8, ["onClickNav", "main-active-index", "items"])
    ]),
    _createVNode(_component_Tabbar),
    (_ctx.showCart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_van_icon, {
            name: _ctx.cartImg,
            badge: _ctx.appVo.cartInfo.count,
            size: "3.5rem",
            onClick: _ctx.cart_click
          }, null, 8, ["name", "badge", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}